export const maxTableRows = 5;

